import { Component, OnInit } from '@angular/core';
import { NetflixBuyAndSellStatus } from '@dch/products-business-logic';

@Component({
  selector: 'mprd-order-confirmation-modal',
  templateUrl: './order-confirmation-modal.component.html',
})
export class OrderConfirmationModalComponent implements OnInit {
  public destroy: () => void;
  private el: HTMLElement;
  dispatchAlert: () => void;
  packDescription: string;
  netflixBuyAndSellStatus: NetflixBuyAndSellStatus;

  NetflixBuyAndSellStatus = NetflixBuyAndSellStatus;

  ngOnInit(): void {
    this.el = document.getElementById('px-msg-overlayer');
    if (this.el) {
      this.el.classList.add('rs-reveal-modal-neg');
    }
  }

  close() {
    this.destroy();
    this.dispatchAlert();
  }
}
